import { stylesheet } from 'typestyle';
import { colors, font, spacers } from '../../assets/styles';

const styles = stylesheet({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: spacers.pageMargin,
    paddingTop: '50px',
    paddingBottom: '40px',
    minHeight: '80vh',
    justifyContent: 'space-between',
  },
  contentWrapper: {},
  header: {
    color: colors.foreground,
    fontWeight: font.weight.bold,
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '-0.15px',
    textAlign: 'center',
    marginBottom: '6px',
  },
  subHeader: {
    color: colors.foregroundLighter,
    fontSize: '16px',
    lineHeight: '20px',
    textAlign: 'center',
    marginBottom: 40,
    paddingLeft: 2,
    paddingRight: 2,
  },
  scheduleWrapper: {
    fontWeight: font.weight.bold,
    fontSize: '16px',
    lineHeight: '19px',
    // @ts-ignore
    letter: '-0.12px',
    textAlign: 'center',
    marginTop: 34,
  },
  schedule: {
    fontWeight: font.weight.regular,
    fontSize: '16px',
    lineHeight: '19px',
    textAlign: 'center',
    marginTop: 6,
  },
  time: {
    color: colors.foreground,
    fontWeight: font.weight.bold,
    fontSize: '24px',
    lineHeight: '30px',
    letterSpacing: '-0.18px',
    marginTop: 8,
    marginBottom: 30,
  },
  button: {
    fontSize: '16px !important',
    fontWeight: font.weight.bold,
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  access: {
    marginTop: 20,
    marginBottom: -6,
  },
  buttonsWrapper: {
    width: '100%',
  },
  bottomWrapper: {
    width: '100%',
  },
  icon20: {
    width: 20,
    height: 'auto',
    marginLeft: 10,
  },
});

export default styles;
